import useAuth from '@/hooks/useAuth';
import { useState, useEffect } from 'react';
import config from '../../config';
import DashboardSidebar from './components/DashboardSidebar';
import Header from '../../components/Header';
import { getRequest } from '@/services/api';
import PatientsList from './components/Patients';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import formatDateTimeUK from '@/helpers/formatDateTimeUK';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

const PatientRecords = () => {
	const { user } = useAuth();
	const [patients, setPatientsRequests] = useState(null);

	const [selectedPatient, setSelectedPatient] = useState(null);
	const [patientDocuments, setPatientDocuments] = useState(null);

	const handleBack = () => {
		setSelectedPatient(null);
		setPatientDocuments(null);
	};

	const handleRowClick = async (patient_id) => {
		setSelectedPatient(patient_id);
	};

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	useEffect(() => {
		const fetchPatientRecords = async () => {
			if (!selectedPatient) return;
			try {
				const response = await fetch(
					`${config.REACT_APP_API_URL}/documents?customer=${selectedPatient}`
				);
				const data = await response.json();
				setPatientDocuments(data);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchPatientRecords();
	}, [selectedPatient]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await fetch(
					`${config.REACT_APP_API_URL}/customers/business-partner/${user.customer_id}/customers`
				);
				const data = await response.json();
				setPatientsRequests(data.customers);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};
		fetchData();
	}, [user?.customer_id]);

	const handleDownload = async (document) => {
		try {
			const response = await fetch(
				`${config.REACT_APP_API_URL}/documents/download?customer=${
					user.customer_id
				}&file=${encodeURIComponent(document.file_name)}`
			);

			if (!response) {
				throw new Error('Failed to fetch PDF file.');
			}

			const blob = await response.blob();
			const file = window.URL.createObjectURL(blob);
			window.open(file);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	return (
		<>
			<Header />
			<div className="container mt-25">
				<div className="row">
					<div className="col-md-5 col-lg-4 col-xl-3">
						<DashboardSidebar user={user} />
					</div>

					<div className="col-md-7 col-lg-8 col-xl-9">
						<div className="row">
							<div className="card border-0 col-sm-12 d-flex flex-column gap-1">
								{selectedPatient ? (
									<>
										<div
											style={{
												position: 'relative',
												width: '100%',
												padding: '20px 20px 30px 20px',
												textAlign: 'center',
											}}
										>
											<button
												onClick={handleBack}
												style={{
													padding: '8px 10px',
													fontSize: '12px',
													backgroundColor: '#007bff',
													color: '#fff',
													border: 'none',
													borderRadius: '5px',
													cursor: 'pointer',
													display: 'inline-flex',
													alignItems: 'center',
													gap: '5px',
													position: 'absolute',
													left: '20px',
												}}
											>
												<ArrowBackIcon /> Back to Patient List
											</button>

											<h4 style={{ margin: 0 }}>Documents for Patient ID: {selectedPatient}</h4>
										</div>

										{patientDocuments ? (
											<Box sx={{ width: '100%' }}>
												<Paper sx={{ width: '100%', mb: 2, p: 2 }}>
													{patientDocuments && patientDocuments.length >= 1 ? (
														<>
															<TableContainer
																style={{ overflowX: 'auto', width: '100%', overflowY: 'auto' }}
															>
																Note: Files here will be available for you to download for 30 days,
																before being deleted from our system.
																<Table sx={{ minWidth: 650 }} aria-label="patient documents table">
																	<TableHead>
																		<TableRow>
																			<TableCell>#</TableCell>
																			{/* <th>CustomerID</th> */}
																			{/* <th>DocumentID</th> */}
																			<TableCell>File Name</TableCell>
																			<TableCell>Description</TableCell>
																			<TableCell>Date</TableCell>
																			<TableCell>Attachment</TableCell>
																		</TableRow>
																	</TableHead>

																	<TableBody>
																		{patientDocuments
																			?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
																			.map((document, index) => (
																				<TableRow key={index}>
																					<TableCell>{index + 1}</TableCell>
																					{/* <td>{document.customer_id}</td> */}
																					{/* <td>{document.document_id}</td> */}
																					<TableCell>{document.file_name}</TableCell>
																					<TableCell>{document.document_type}</TableCell>
																					<TableCell>
																						{formatDateTimeUK(document.created_at)}
																					</TableCell>
																					<TableCell>
																						<button
																							onClick={() => handleDownload(document)}
																							className="btn btn-primary btn-sm"
																						>
																							<i className="fa fa-download" />
																						</button>
																					</TableCell>
																				</TableRow>
																			))}
																	</TableBody>
																</Table>
															</TableContainer>
															<TablePagination
																rowsPerPageOptions={[5, 10, 25]}
																component="div"
																count={patientDocuments?.length}
																rowsPerPage={rowsPerPage}
																page={page}
																onPageChange={handleChangePage}
																onRowsPerPageChange={handleChangeRowsPerPage}
															/>
														</>
													) : (
														<>
															<p>No available patient documents</p>
														</>
													)}
												</Paper>
											</Box>
										) : (
											<p>Loading documents...</p>
										)}
									</>
								) : (
									<PatientsList patients={patients} handleRowClick={handleRowClick} />
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PatientRecords;
